import styled from 'styled-components';

export const StyledSearchInputContainer = styled.div<{ isFocused: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xxxl};
  padding: 14px;
  border: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.minorText};
  outline: none;
  transition: all 0.3s;
  ${({ isFocused, theme }): string =>
    isFocused &&
    ` 
    border: ${theme.borders[0]};
    border-color: ${theme.colors.primaryBlue};
    box-shadow: 0px 0px 10px 0px rgba(0, 193, 255, 0.4);
  `}
`;

export const StyledSearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  color: ${({ theme }): string => theme.colors.normalText};
  ::placeholder {
    color: ${({ theme }): string => theme.colors.minorText};
  }
`;
